import { render, staticRenderFns } from "./pageone.vue?vue&type=template&id=33408758&scoped=true"
import script from "./pageone.vue?vue&type=script&lang=js"
export * from "./pageone.vue?vue&type=script&lang=js"
import style0 from "./pageone.vue?vue&type=style&index=0&id=33408758&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33408758",
  null
  
)

export default component.exports